import { Component, OnInit, Renderer2 } from '@angular/core';
import { ClubFlightService } from "src/providers/club-flight-service/club-flight-service";
import { ClubData } from "src/data/mygolf.data";
import { NavController, NavParams, ModalController, LoadingController } from "@ionic/angular";
import { AuthenticationService } from "src/authentication-service";
import { getDistanceInKM } from "src/globals";
import { ClubInfo, ClubList, createClubList, CourseInfo } from "src/data/club-course";
import { GeolocationService } from "src/providers/geolocation-service/geolocation-service";
import { ClubService } from "src/providers/club-service/club-service";
import { JsonService } from 'src/json-util';

@Component({
    selector: 'app-program-club-list',
    templateUrl: './program-club-list.page.html',
    styleUrls: ['./program-club-list.page.scss'],
})
export class ProgramClubListPage implements OnInit {
    public refresher: any;
    public infinite: any;

    public clubList: any;
    public openedModal: boolean = false;
    public searchQuery: string = "";
    public courseId: number;
    public courseName: string;
    public prevClubName: string;
    public prevCourseInfo: CourseInfo;
    public courseType: string;
    public clubInfo: ClubInfo;
    public prevClubInfo: ClubInfo;
    public multiSelect: boolean = false;
    programId: string;
    multiClub: Array<ClubData> = new Array<ClubData>();

    constructor(private nav: NavController,
        private navParams: NavParams,
        private renderer: Renderer2,
        private auth: AuthenticationService,
        private modalCtl: ModalController,
        private geo: GeolocationService,
        private clubService: ClubService,
        // private events: Events,
        private loadingCtl: LoadingController,
        private flightService: ClubFlightService) {
        this.clubList = createClubList();
        this.openedModal = navParams.get("openedModal");

        this.prevCourseInfo = navParams.get("courseInfo");
        this.prevClubName = navParams.get("clubName");

        this.courseId = navParams.get("courseId");
        this.courseName = navParams.get("courseName");
        this.courseType = navParams.get("courseType");

        this.clubInfo = navParams.get("clubInfo");
        this.prevClubInfo = navParams.get("clubInfo");

        this.multiSelect = navParams.get("multiSelect");
        this.programId = navParams.get("programId");
    }

    ngOnInit() {
        this._refreshClubs();
    }


    ionViewDidEnter() {
        // adjustViewZIndex(this.nav, this.renderer);
    }

    onSearchInput(event) {
        this._clearItems();
        this._refreshClubs();
    }

    /**
     * Gets the distance between a current location and club in KMs
     * @param club The club information
     * @returns {number} Returns the distance in KM if GPS locations of current and club are available
     * else returns 0;
     */
    clubDistance(club: ClubInfo): string {
        let lat1 = this.geo.getLatitude();
        let lon1 = this.geo.getLongitude();
        if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
            return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + " KM";
        return "";
    }

    /**
     * Executed when refresh button on toolbar is clicked
     */
    onRefreshClick(refresher) {
        this._clearItems();
        this._refreshClubs();
    }

    doInfinite(infinite) {
     
        if (this.isMore()) {
            this._refreshClubs();
        }

    }

    clubSelected(event, item: any) {
        this.onMultiClubSelected(item);
        if (1) return false;
        if (this.openedModal) this.modalCtl.dismiss({ clubInfo: item });
    }

    close() {
        this.modalCtl.dismiss({ courseInfo: this.prevCourseInfo, clubInfo: this.prevClubName });
    }

    private _clearItems() {
        this.clubList = createClubList();
    }
    public _refreshClubs() {
        let _programId = this.programId;
        this.flightService.listDiscountProgramsClub(_programId)
            .subscribe((data) => {
  
                if (data) {
                    let clubList = data;
                    if (clubList.success && clubList.totalItems > 0) {
                        this.clubList.currentPage = clubList.currentPage;
                        this.clubList.totalPages = clubList.totalInPage;
                        this.clubList.totalItems = clubList.totalItems;
                        this.clubList.clubs.push(...clubList.items);
                        this.clubList.clubs.forEach((club: ClubData) => {
                            JsonService.deriveFulImageURL(club, 'clubImage');
                            JsonService.deriveFulImageURL(club, 'clubThumbnail');
                            JsonService.deriveFulImageURL(club, 'clubLogo');
                        })
                    }
                }
            })
    }

    isMore(): boolean {
        return this.clubList.totalPages > 0
            && this.clubList.currentPage < this.clubList.totalPages;
    }

    onMultiClubSelected(item: ClubData) {
        let _hasClub;
     
        if (this.multiClub && this.multiClub.length > 0) {
            _hasClub = this.multiClub.filter((c) => {
                if (c.id === item.id) return true;
                else return false;
            });
            if (_hasClub && _hasClub.length > 0) return false;
            else this.multiClub.push(item);
        } else {
            this.multiClub.push(item);
        }

     
    }

    getMultiClubText() {
        let _clubList = '';
        this.multiClub.forEach((c: ClubData, idx: number, arr) => {
            if(idx === arr?.length - 1) 
                _clubList += c.name;
            else _clubList += c.name + ', ';
        });
        return _clubList; //.slice(0,-1);// .substring(0,_playersList.length-1);

    }

    clearMultiClub() {
        this.multiClub.pop();
    }

    selectMultiClubs() {
        this.modalCtl.dismiss({
            confirm: true,
            multiClub: this.multiClub,
        })
    }

    getClubAddress(club: ClubData) {
        let _address = '';
        if (club.address) {
            _address += club.address.address1 ? club.address.address1 + ', ' : '';
            _address += club.address.address2 ? club.address.address2 + ', ' : '';
            _address += club.address.city ? club.address.city + ', ' : '';
            _address += club.address.state ? club.address.state + ', ' : '';
            _address += club.address.countryData.name ? club.address.countryData.name : '';
        } else _address = null;
        return _address;
    }

    getClubImage(club: ClubData) {
        let _imageUrl;
        if (club.clubThumbnail) _imageUrl = club.clubThumbnail;
        else if (club.clubImage) _imageUrl = club.clubImage;
        else if (club.clubLogo) _imageUrl = club.clubLogo;
        else _imageUrl = '';
        return _imageUrl;
    }

}
